import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userDataActions from '../../../actions/userDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as animationHelper from "../../../helpers/animationHelper";

class AssetImage extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            screenObject: this.props.screenObject,
            userData: this.props.userData,
            status: objectConstants.STATUS_NOT_STARTED,
            locale: appHelper.getLocalData(this.props.screenObject),
            showProgressionButton: false,
            image: {},
            screenStatus:"",
            filter: "landscape",
            checkComplete: false,
            isResourceObject: appHelper.isDefined(this.props.callbacks.checkIsResourceScreen) && this.props.callbacks.checkIsResourceScreen(),
            imageRevealed: false,
            done_label: appHelper.getLocaleString("done_label")

        };
        this.getAssets = this.getAssets.bind(this);
        this.show = this.show.bind(this);
        this.setClass = this.setClass.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getImageClass = this.getImageClass.bind(this);
        this.onImageRevealed = this.onImageRevealed.bind(this);
        this.getFilterBtnClass = this.getFilterBtnClass.bind(this);
        this.setFilterWidth = this.setFilterWidth.bind(this);
        this.setFilterHeight = this.setFilterHeight.bind(this);

        this.objectRef = React.createRef();
    }

    componentDidMount() {
        this.getAssets();
        this.show();
        if (appHelper.isDefined(this.props.callbacks.updateCharacterExpression) && appHelper.isDefined(this.state.screenObject.character_pose)) {
            this.props.callbacks.updateCharacterExpression(this.state.screenObject.character_pose);
        }
    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            let image = appHelper.getImageAsset(this.state.screenObject);
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                image: appHelper.isDefined(image.locale) ? appHelper.getLocalData(image) : image,
                done_label: appHelper.getLocaleString("done_label")
            });
        }
    }

    componentDidUpdate(){
        if(this.state.checkComplete){
            this.onComplete();
        }
    }

    getAssets() {
        let image = appHelper.getImageAsset(this.state.screenObject);
        this.setState({image: appHelper.isDefined(image.locale) ? appHelper.getLocalData(image) : image});
    }

    show() {
        let objectRef = this.objectRef.current;
        if(appHelper.isObjectEleDefined(objectRef)) {
            let params = {
                ele: objectRef,
                duration: objectConstants.SHOW_PANEL_DURATION,
                delay: 0,
                callback: this.onImageRevealed
            };
            animationHelper.fadeIn(params);
        }
    }

    onImageRevealed(){
        this.setState({imageRevealed: true});
        this.props.onAssetViewed();
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setClass() {
        return this.state.imageRevealed ? "viewable" : "hidden";
    }


    getImageClass(){
        return this.state.filter;
    }

    getFilterBtnClass(value){
        return value === this.state.filter ? 'active' : '';
    }

    setFilterWidth(){
        this.setState({filter: "landscape"});
    }

    setFilterHeight(){
        this.setState({filter: "portrait"});
    }

    render() {
        return (
            <div className="a-co" ref={this.objectRef}>
                <div className={`object-container`}>
                    <div className={`asset-dialog-image `}>
                        <div className="asset-image-header">
                            <div className="title-col truncate-text-container">
                                <div className="title" dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                            </div>
                            <div className="nav-col">
                                <div className="btn-group text-right icon-btn-group">
                                    <button type="button" className={`btn guroo-btn ${this.getFilterBtnClass("landscape")}`} id="landscape_image" onClick={this.setFilterWidth}><span className="icon icons8-width-filled"/> </button>
                                    <button type="button" className={`btn guroo-btn ${this.getFilterBtnClass("portrait")}`} id="portrait_image" onClick={this.setFilterHeight}><span className="icon icons8-height-filled"/></button>

                                </div>
                                &nbsp;
                                <button className={`btn guroo-btn`} onClick={this.props.closeDialog} id="image_close_btn">{this.state.done_label}</button>
                            </div>
                        </div>
                        <div className={`asset-img-container ${this.getImageClass()}`}>
                            <div className="img-container">
                                <img src={this.getImagePath(this.state.image.src)} className={``} alt={this.state.locale.label} />
                            </div>
                            {
                                appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                                ?
                                    <div className="asset-desc">
                                        <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                    </div>
                                :
                                    null
                            }

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

AssetImage.propTypes = {
    screenObject: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    onAssetViewed: PropTypes.func.isRequired,
    closeDialog: PropTypes.func.isRequired,
    index: PropTypes.number,
    userData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

AssetImage.contextTypes = {
    router: PropTypes.object
};


function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        userData: state.userData
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssetImage);



/** WEBPACK FOOTER **
 ** ./src/components/objects/image/AssetImage.js
 **/